import styled from "styled-components";
import { ContentWrapper } from "../AddArea/style";

export const CustomContentWrapper = styled(ContentWrapper)``